(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-banner"] && !Shopify.designMode) return;
  try {
    
  function initBannerSlideshows() {
    document.querySelectorAll('.banner-slideshow').forEach((section) => {
      if (section.dataset.slideshowInitialized) return;
      section.dataset.slideshowInitialized = 'true';

      const slides = Array.from(section.querySelectorAll('.banner-slideshow__slide'));
      if (slides.length < 2) return;

      let current = 0;
      setInterval(() => {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, 4000);
    });
  }

  document.addEventListener('DOMContentLoaded', initBannerSlideshows);
  document.addEventListener('shopify:section:load', initBannerSlideshows);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery-modal"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function () {
		document.querySelectorAll('.video-card__wrapper').forEach(function (wrapper) {
			var trigger = wrapper.querySelector('.video-card__trigger');
			var dialog = wrapper.querySelector('dialog');
			var iframe = wrapper.querySelector('iframe[data-youtube-id]');

			if (!trigger || !dialog || !iframe) return;

			var videoId = iframe.getAttribute('data-youtube-id');

			trigger.addEventListener('click', function () {
				iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
			});

			dialog.addEventListener('close', function () {
				iframe.src = '';
			});
		});
	});

  } catch(e) { console.error(e); }
})();
})();
